import { ArrowUpRight, Lock } from "lucide-react";
import { Link } from "react-router-dom";

const MODULES = {
  "Amministrazione e controllo": {
    plan: "Standard",
    intro: "Il modulo Amministrazione e controllo tiene insieme sedi, clienti e il report di produzione: l'anagrafica su cui poggiano commesse, preventivi e report.",
    benefits: [
      "Sedi aziendali e magazzini collegati a ogni movimento",
      "Anagrafica clienti con storico commesse e preventivi",
      "Report produzione con ore previste, ore reali e sforamenti",
      "Utenti e permessi per reparto",
    ],
  },
  "Logistica generale e utensili": {
    plan: "Easy Tool",
    intro: "Il modulo Logistica generale e utensili è il cuore del magazzino: catalogo tecnico, giacenze di utensili, materie prime, ricambi, semilavorati e attrezzature, movimenti e riordini.",
    benefits: [
      "Catalogo utensili e attacchi base con schede tecniche",
      "Magazzini, posizioni e inventario sempre aggiornato",
      "Movimenti tracciati: carichi, prelievi, resi e trasferimenti",
      "Scorte minime, consumi e ordini di acquisto",
    ],
  },
  "Produzione": {
    plan: "Standard",
    intro: "Il modulo Produzione porta commesse, componenti e fasi su un'unica timeline, con macchine e carichi sotto controllo.",
    benefits: [
      "Commesse, componenti e fasi con planner settimanale e Kanban",
      "Avanzamento officina con ore reali, pezzi buoni e scarti",
      "Parco macchine con curve coppia/potenza e idoneità",
      "Report di chiusura commessa ed efficienza delle fasi",
    ],
  },
  "Acquisti e fornitori": {
    plan: "Standard",
    intro: "Il modulo Acquisti e fornitori porta in officina tutto il ciclo passivo: anagrafica fornitori, proposte di riordino, ordini di acquisto e arrivo merce che carica il magazzino.",
    benefits: [
      "Anagrafica fornitori con listini, condizioni, certificazioni e valutazione",
      "Proposte di acquisto automatiche per utensili, materie prime e ricambi sotto scorta",
      "Ordini di acquisto con righe, sconti, consegne attese e stampa PDF",
      "Arrivo merce che aggiorna giacenze e registro movimenti",
    ],
  },
  "Qualità": {
    plan: "Premium",
    intro: "Il modulo Qualità aggiunge tutto quello che serve quando un cliente o un ente di certificazione chiede prove documentate.",
    benefits: [
      "Piani di controllo con quote, strumenti e frequenze",
      "Controlli eseguiti con andamento delle quote e tolleranze",
      "Non conformità, azioni correttive e scadenze presidiate",
      "Report di direzione pronto per gli audit ISO 9001 e IATF",
    ],
  },
  "Preventivazione": {
    plan: "Premium",
    intro: "Il modulo Preventivazione trasforma geometrie e lavorazioni in tempi, costi e prezzo di offerta, senza fogli di calcolo.",
    benefits: [
      "Preventivi rapidi con tempi e costi calcolati dai parametri di taglio",
      "Costo industriale, margine e prezzo proposto su più quantità",
      "Tariffa oraria per macchina e valori predefiniti aziendali",
      "Stati, approvazioni e revisioni immutabili con le tariffe storicizzate",
    ],
  },
  "Controllo di gestione": {
    plan: "Premium",
    intro: "Il modulo Controllo di gestione trasforma i dati già presenti in officina in margini, scostamenti e obiettivi misurabili, senza diventare un software di contabilità.",
    benefits: [
      "Tariffe macchina e costi manodopera storicizzati, con snapshot sulle commesse",
      "Costo industriale consuntivo (manodopera, materiale, utensili) e margine per commessa e cliente",
      "Report marginalità, report clienti, scheda cliente e prezzi di vendita",
      "Obiettivi, semafori e alert direzionale settimanale via email",
    ],
  },
};

export function PlanLockedModule({ module = "Qualità" }) {
  const detail = MODULES[module] || MODULES["Qualità"];
  return (
    <section className="plan-locked" data-testid="plan-locked-module">
      <span className="plan-locked-mark"><Lock size={20} /></span>
      <p className="eyebrow">MODULO NON ATTIVO</p>
      <h2>Il modulo {module} è disponibile dal piano {detail.plan}</h2>
      <p className="plan-locked-text" data-testid="plan-locked-intro">{detail.intro}</p>
      <ul className="plan-locked-list">
        {detail.benefits.map((benefit) => <li key={benefit}>{benefit}</li>)}
      </ul>
      <Link className="primary-button" to="/piano" data-testid="plan-locked-cta">Vedi i piani <ArrowUpRight size={16} /></Link>
    </section>
  );
}
